module.exports = __webpack_public_path__ + "img/img-5mobile.39efb05d.webp";